module.exports = __webpack_public_path__ + "static/media/AboutPicture.5e8c37b7.svg";